import { api } from "./client";

export type MediaClip = {
  id: number;
  project: number;
  name: string;
  type: "video" | "audio" | "image";
  status: "uploading" | "processing" | "ready" | "failed";
  size_bytes: number;
  duration_ms: number;
  width: number;
  height: number;
  fps: number;
  has_audio: boolean;
  proxy_url: string | null;
  thumb_url: string | null;
  original_url: string | null;
  error_message: string;
  created_at: string;
};

export async function listClips(projectId: number): Promise<MediaClip[]> {
  const r = await api.get(`/media/clips/?project=${projectId}`);
  return r.data.results || r.data;
}

export async function deleteClip(clipId: number) {
  await api.delete(`/media/clips/${clipId}/`);
}

const CHUNK = 8 * 1024 * 1024;  // 8 MiB

export async function uploadFile(
  projectId: number,
  file: File,
  onProgress?: (pct: number) => void,
): Promise<MediaClip> {
  const init = await api.post("/media/uploads/init/", {
    project_id: projectId,
    filename: file.name,
    total_bytes: file.size,
    content_type: file.type || "",
  });
  const sessionId = init.data.id as number;

  let sent = 0;
  while (sent < file.size) {
    const chunk = file.slice(sent, sent + CHUNK);
    await api.put(`/media/uploads/${sessionId}/chunk/`, chunk, {
      headers: {
        "Content-Disposition": `attachment; filename="${file.name}.part"`,
        "Content-Type": "application/octet-stream",
      },
    });
    sent += chunk.size;
    onProgress?.(Math.round((sent / file.size) * 100));
  }

  const done = await api.post(`/media/uploads/${sessionId}/complete/`);
  return done.data;
}
